import { render, staticRenderFns } from "./SetHttp.vue?vue&type=template&id=6c06704a&scoped=true&"
import script from "./SetHttp.vue?vue&type=script&lang=js&"
export * from "./SetHttp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06704a",
  null
  
)

export default component.exports